<template>
  <div>
    <section id="searchBar" v-if="!isLandingPage">
      <div class="container">
        <form>
          <div class="row-sm">
            <div class="col">
              <label class="sr-only" for="search-keywords">Keywords</label>
              <input
                id="search-keywords"
                placeholder="Enter keyword(s)"
                type="search"
                v-model="keyword"
              />
            </div>
            
            <div class="d-none d-block-sm col">
              <label class="sr-only" for="search-location">Location</label>
              <input
                id="search-location"
                placeholder="Enter Location"
                type="text"
                v-model="location"
              />
            </div>

            <div class="col-auto">
              <button
                class="btn btn-primary"
                v-on:click.prevent="mainSearch"
                :disabled="isNotValid"
              >Search</button>
            </div>

            <div class="col-auto">
              <button
                class="btn btn-secondary btn-icon d-none-lg"
                type="button"
                data-modal="advancedSearchModal"
                @click="openModal"
              >
                <span class="sr-only">Advanced Search</span>
                <i class="icomoon icon-plus" aria-hidden="true"></i>
              </button>
              <button
                class="btn btn-secondary d-none d-block-lg"
                type="button"
                data-modal="advancedSearchModal"
                @click="openModal"
              >
                Advanced Search
                <i class="icomoon icon-plus is-right" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </section>
    <form v-else v-on:submit.prevent="mainSearch" class="form-lg">
      <label class="sr-only" for="search-keywords">Keywords</label>
      <input id="search-keywords" v-model="keyword" placeholder="Enter keyword(s)" type="search" />

      <div class="row-sm">
       
        <div class="col-sm">
          <label class="sr-only" for="search-location">Location</label>
          <input id="search-location" placeholder="Enter Location" type="text" v-model="location" />
        </div>
        
        <div class="col-auto">
          <button class="btn btn-primary btn-lg" type="submit" :disabled="isNotValid">Search</button>
        </div>

        <div class="col-auto">
          <button
            class="btn btn-secondary btn-lg"
            type="button"
            data-modal="advancedSearchModal"
            @click="openModal"
          >
            Advanced Search
            <i class="icomoon icon-plus is-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </form>
    

    <div
      id="advancedSearchModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="advancedSearchModal__title"
    >
      <Trap :disabled="trapActive">
        <div class="modal__dialog">
          <button
            class="btn btn-icon modal__dialog__close"
            type="button"
            id="modalCloseButton"
            data-modal-close
            @click="closeModal"
          >
            <i class="icomoon icon-close" aria-hidden="true"></i>
            <span class="sr-only">Close modal</span>
          </button>

          <h2 id="advancedSearchModal__title" class="modal__title">Advanced Search</h2>

          <form class="form-lg">
            <div class="row-sm row-cols-1">
              <div class="col">
                <label class="sr-only" for="advancedSearchKeywords">Keywords</label>
                <input
                  id="advancedSearchKeywords"
                  v-model="keyword"
                  placeholder="Enter keyword(s)"
                  type="search"
                />
              </div>
            </div>

            <div class="row-sm row-cols-1 row-cols-sm-2">
              
            <div class="col">
              <label class="sr-only" for="advancedSearchLocation">Location</label>
              <input
                id="advancedSearchLocation"
                placeholder="Enter Location"
                type="text"
                v-model="location"
              />
            </div>
              
              <div class="col">
                <label class="sr-only" for="advancedSearchRegions">Regions</label>
                <select
                  id="advancedSearchRegions"
                  name="advancedSearchRegionsSelect"
                  v-model="selectedServiceRegion"
                >
                  <option value="null" selected>Regions</option>
                  <option
                    v-for="serviceRegion in serviceRegions"
                    :key="serviceRegion.id"
                    :value="serviceRegion.id"
                  >{{serviceRegion.name}}</option>
                </select>
              </div>
              
            <div class="col">
              <label class="sr-only" for="advancedSearchCOR">COR</label>
              <select
                id="advancedSearchCOR"
                name="advancedSearchCORSelect"
                v-model="selectedCorCertified"
              >
                <option value="false" selected>COR</option>
                <option
                  v-for="option in yesAnyOptions"
                  :value="option.value"
                  :key="option.value"
                >{{option.text}}</option>
              </select>
            </div>

            <div class="col">
              <label class="sr-only" for="advancedSearchBonding">Bonding</label>
              <select
                id="advancedSearchBonding"
                name="advancedSearchBondingSelect"
                v-model="selectedBondableCompany"
              >
                <option value="false" selected>Bonding</option>
                <option
                  v-for="option in yesAnyOptions"
                  :value="option.value"
                  :key="option.value"
                >{{option.text}}</option>
              </select>
            </div>

            <div class="col">
              <label class="sr-only" for="advancedSearchWCB">{{ wsibName }}</label>
              <select
                id="advancedSearchWCB"
                name="advancedSearchWCBSelect"
                v-model="selectedWcbCertified"
              >
                <option value="false" selected>{{ wsibName }}</option>
                <option
                  v-for="option in yesAnyOptions"
                  :value="option.value"
                  :key="option.value"
                >{{option.text}}</option>
              </select>
            </div>

            <div class="col">
              <label class="sr-only" for="advancedSearchLiability">Liability</label>
              <select
                id="advancedSearchLiability"
                name="advancedSearchLiabilitySelect"
                v-model="selectedLiabilityInsurance"
              >
                <option value="null" selected>Liability</option>
                <option
                  v-for="insurance in liabilityInsurances"
                  :key="insurance.id"
                  :value="insurance.id"
                >{{insurance.name}}</option>
              </select>
            </div>
              
            </div>

            <div class="row-sm">
              <div class="col-auto">
                <button
                  class="btn btn-primary btn-lg"
                  v-on:click.prevent="mainSearch"
                  :disabled="isNotValid"
                >Search</button>
              </div>

              <div class="col-auto">
                <button class="btn btn-secondary btn-lg" type="button" @click="clear">Clear Form</button>
              </div>
            </div>
          </form>
        </div>
      </Trap>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Trap from "vue-focus-lock";

export default {
  name: "Company",
  components: { Trap },
  data() {
    return {
      loading: true,
      errored: false,
      focusLock: false,
      location: "",
      keyword: "",
      selectedCorCertified: false,
      selectedWcbCertified: false,
      selectedBondableCompany: false,
      selectedServiceRegion: null,
      selectedLiabilityInsurance: null,

      yesAnyOptions: [
        { text: "Yes", value: true },
        { text: "All", value: false }
      ],
      criteria: {
        liabilityInsuranceBuckets: [],
        serviceRegionBuckets: [],
        corCertified: false,
        wcbCertified: false,
        bondableCompany: false,
        unionAffiliated: false,
        provinceBuckets: [],
        associationBuckets: []
      },
      filterQuery: "",
      apiUrl: process.env.VUE_APP_API_URL
    };
  },
  props: {
    isLandingPage: {
      type: Boolean
    },
    isDetailPage: {
      type: Boolean
    }
  },
  async created() {
    if (this.serviceRegions && !this.serviceRegions.length > 0)
      await this.loadServiceRegions();
    if (this.liabilityInsurances && !this.liabilityInsurances.length > 0)
      await this.loadLiabilityInsurances();

    if (this.searchCrieteria) {
      this.keyword = this.searchCrieteria.keyword;
      this.location = this.searchCrieteria.location;
      this.selectedCorCertified = this.searchCrieteria.selectedCorCertified;
      this.selectedWcbCertified = this.searchCrieteria.selectedWcbCertified;
      this.selectedBondableCompany = this.searchCrieteria.selectedBondableCompany;
      this.selectedServiceRegion = this.searchCrieteria.selectedServiceRegion;
      this.selectedLiabilityInsurance = this.searchCrieteria.selectedLiabilityInsurance;
    }
  },
  methods: {
    ...mapActions([
      "fetchCompanies",
      "fetchServiceRegions",
      "fetchLiabilityInsurances"
    ]),
    async loadServiceRegions() {
      try {
        let url = `${this.apiUrl}api/v1/service-regions`;
        await this.fetchServiceRegions(url);
      } catch (error) {
        this.errored = true;
      } finally {
        this.loading = false;
      }
    },
    async loadLiabilityInsurances() {
      try {
        let url = `${this.apiUrl}api/v1/liability-insurances`;
        await this.fetchLiabilityInsurances(url);
      } catch (error) {
        this.errored = true;
      } finally {
        this.loading = false;
      }
    },
    async mainSearch() {
      this.filterQuery = "";
      this.criteria.liabilityInsuranceBuckets = [];
      this.criteria.serviceRegionBuckets= [];
      this.criteria.corCertified= false;
      this.criteria.wcbCertified= false;
      this.criteria.bondableCompany= false;
      this.criteria.unionAffiliated= false;
      this.criteria.provinceBuckets= [];
      this.criteria.associationBuckets= []; 
      this.$emit('clearAndToggleFilter')     

      await this.search(true, true);
    },

    async search(getFacets, setPagination) {
      this.closeModal();
      this.$emit('searching', true);
      if (setPagination && this.pagination) {
        this.pagination.page = process.env.VUE_APP_STATIC_PAGINATION_PAGE;
        this.pagination.perPage =
          process.env.VUE_APP_STATIC_PAGINATION_PER_PAGE;
      }

      let query = "?";
      query += !(this.keyword && this.keyword.length > 0)
        ? ""
        : `keyword=${encodeURIComponent(this.keyword)}&`;
      query += !(this.location && this.location.length > 0)
        ? ""
        : `location=${this.location}&`;
      query += this.selectedCorCertified ? `selectedCorCertified=true&` : "";
      query += this.selectedWcbCertified ? `selectedWcbCertified=true&` : "";
      query += this.selectedBondableCompany
        ? `selectedBondableCompany=true&`
        : "";
      query += !this.selectedServiceRegion || this.selectedServiceRegion === "null"
        ? ""
        : `ServiceRegionId=${this.selectedServiceRegion}&`;
      query += !this.selectedLiabilityInsurance || this.selectedLiabilityInsurance === "null"
        ? ""
        : `liabilityInsuranceId=${this.selectedLiabilityInsurance}&`;
      //add filterQuery
      query += this.filterQuery;

      query += getFacets ? `getFacets=true&` : "";
      query += `PageSize=${this.pagination.perPage}&`;
      query += `Page=${this.pagination.page}`;

      this.criteria.keyword = this.keyword;
      this.criteria.location = this.location;
      this.criteria.selectedCorCertified = this.selectedCorCertified;
      this.criteria.selectedWcbCertified = this.selectedWcbCertified;
      this.criteria.selectedBondableCompany = this.selectedBondableCompany;
      this.criteria.selectedServiceRegion = this.selectedServiceRegion;
      this.criteria.selectedLiabilityInsurance = this.selectedLiabilityInsurance;

      try {
        let url = `${this.apiUrl}api/v1/companies/search` + query;
        await this.fetchCompanies({
          url,
          getFacets,
          searchCrieteria: this.criteria
        });
      } catch (error) {
        this.errored = true;
      } finally {        
        this.$emit('searching', false);

        if ((this.isLandingPage && this.companies.length > 0) || this.isDetailPage) {
          this.$router.push("search");
        }
        if (!(this.companies && this.companies.length > 0)){
          this.$emit('noResultFound', true);
        }
        else{
          this.$emit('noResultFound', false);
        }
      }
    },
    arrayParams(array, paramName) {
      let params = array.map(v => {
        return `${paramName}=${v}&`;
      });
      return params.join("");
    },
    clear() {
      this.location = "";
      this.keyword = "";
      this.selectedCorCertified = false;
      this.selectedWcbCertified = false;
      this.selectedBondableCompany = false;
      this.selectedServiceRegion = null;
      this.selectedLiabilityInsurance = null;
    },
    closeModal() {
      let modal = document.getElementById("advancedSearchModal");
      modal.classList.remove("modal--visible");
      this.focusLock = false;
      document.getElementsByTagName("body")[0].style.overflow = null;
    },
    openModal() {
      let modal = document.getElementById("advancedSearchModal");
      modal.classList.add("modal--visible");
      this.focusLock = true;
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
    }
  },
  computed: {
    ...mapState([
      "pagination",
      "serviceRegions",
      "searchCrieteria",
      "companies",
      "liabilityInsurances"
    ]),

    wsibName(){
     return process.env.VUE_APP_TENANT_NAME.toLowerCase() === 'link2build' ? 'WSIB' : 'WCB'
    },

    isNotValid() {
      return (
        (!this.keyword ||
          this.keyword.length === 0 ||
          /^\s*$/.test(this.keyword)) &&        
        (!this.location || 
          this.location.length === 0 ||
          /^\s*$/.test(this.location)) &&
        (!this.selectedServiceRegion || this.selectedServiceRegion === "null") &&
        (!this.selectedLiabilityInsurance || this.selectedLiabilityInsurance === "null") &&
        !this.selectedCorCertified && !this.selectedWcbCertified && !this.selectedBondableCompany
      );
    },
    trapActive() {
      return !this.focusLock;
    }
  }
};
</script>
